<form [formGroup]='formGroup' (ngSubmit)='onFormSubmit()'>
  <div class='form-field'>
    <input class='form-input' formControlName='email' type='email' autocomplete='off' placeholder='Email*'>
  </div>
  <div class='form-field'>
    <input class='form-input' formControlName='password' type='password' autocomplete='off' placeholder='Password*'>
  </div>
  <div class='form-field'>
    <button class='dark-button w-full' [disabled]='(disabled|async)'>Login</button>
  </div>
</form>
